/* eslint-disable react/no-unescaped-entities */
import React from "react";
import { motion } from "framer-motion";
import { MapPin, Repeat, HeartHandshake, Store } from "lucide-react";
import ChapterHeading from "./ChapterHeading";
import { fadeUp, staggerParent, viewportOnce } from "../../lib/motion";

const facts = [
  { icon: MapPin, color: "#ED1C24", label: "Un par quartier", line: "Le commerce que tout le monde connaît et fréquente." },
  { icon: Repeat, color: "#68AD45", label: "Plusieurs visites par jour", line: "Les habitants y passent pour l'essentiel du quotidien." },
  { icon: HeartHandshake, color: "#524FA1", label: "Une relation de confiance", line: "Le commerçant connaît ses clients et leurs habitudes." },
  { icon: Store, color: "#231F20", label: "Encore informel", line: "Peu structuré, peu accompagné, peu outillé." },
];

export default function LeConstat() {
  return (
    <section id="le-constat" data-testid="le-constat-section" className="relative bg-white py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <div className="max-w-3xl">
          <ChapterHeading number="01" kicker="Le constat" title="Chaque quartier a son Diallo." />
          <motion.p
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={viewportOnce}
            className="mt-6 text-lg md:text-xl leading-relaxed text-diallo-ink/80"
          >
            Le « Diallo » est le commerce de proximité le plus connu de Côte d'Ivoire. Ce n'est plus un nom —
            c'est devenu une catégorie. On y passe plusieurs fois par jour, et le commerçant connaît chaque
            client. Mais ces boutiques restent informelles, peu accompagnées et peu outillées.
          </motion.p>
        </div>

        <motion.div
          variants={staggerParent}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5"
        >
          {facts.map((f) => {
            const Icon = f.icon;
            return (
              <motion.div
                key={f.label}
                variants={fadeUp}
                whileHover={{ y: -6 }}
                className="rounded-2xl bg-diallo-sand/60 p-7 transition-shadow duration-300 hover:shadow-[0_12px_40px_rgb(0,0,0,0.08)]"
                data-testid={`constat-card-${f.label}`}
              >
                <span
                  className="mb-5 inline-flex h-14 w-14 items-center justify-center rounded-2xl"
                  style={{ backgroundColor: f.color }}
                >
                  <Icon size={26} color="#fff" strokeWidth={2.2} />
                </span>
                <h3 className="font-display font-bold text-xl text-diallo-charcoal">{f.label}</h3>
                <p className="mt-2 text-diallo-ink/70 leading-relaxed">{f.line}</p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
